module.exports = __webpack_public_path__ + "static/media/copy.c4fbd167.svg";